import { render, staticRenderFns } from "./NumerationsConfig.vue?vue&type=template&id=50fc18ea"
import script from "./NumerationsConfig.vue?vue&type=script&lang=js"
export * from "./NumerationsConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50fc18ea')) {
      api.createRecord('50fc18ea', component.options)
    } else {
      api.reload('50fc18ea', component.options)
    }
    module.hot.accept("./NumerationsConfig.vue?vue&type=template&id=50fc18ea", function () {
      api.rerender('50fc18ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/administration/NumerationsConfig.vue"
export default component.exports